import './OrganizationTableInitials.scss';
import { getUserInitials } from 'utilities/userInfo';

export const OrganizationTableInitials = ({ name }: { name: string | null }) => {
  const getInitials = (): string => {
    if (name === null) {
      return getUserInitials(null, null);
    }
    const splitName = name?.split(' ');
    return getUserInitials(splitName[0], splitName[1]);
  };

  return <div className='organization-table-initials'>{getInitials()}</div>;
};
